import { d as i, c as t } from "../../../index-34b1f277.js";
import { EditorOutputAnatomy as e } from "./EditorOutput.anatomy.es.js";
const { defineMultiStyleConfig: l, definePartsStyle: n } = t(
  e.keys
), a = n({
  bold: i({
    fontWeight: "medium"
  }),
  boldItalic: i({ fontWeight: "medium", fontStyle: "italic" }),
  h1: i({}),
  h2: i({}),
  h3: i({}),
  heading: i({
    "& + h1, & + h2, & + h3, & + h4, & + p, & + ul": {
      marginTop: "spacing-200"
    }
  }),
  italic: i({ fontStyle: "italic" }),
  link: i({
    fontSize: "lg",
    display: "inline"
  }),
  orderedList: i({
    marginLeft: "spacing-200",
    marginTop: "spacing-200",
    "& + *": {
      marginTop: "spacing-200"
    },
    listStyleType: "decimal",
    listStylePosition: "outside"
  }),
  list: i({
    marginLeft: "spacing-200",
    marginTop: "spacing-200",
    "& + *": {
      marginTop: "spacing-200"
    },
    listStyleType: "disc",
    listStylePosition: "outside",
    "& ul": {
      listStyleType: "circle"
    },
    "& ul ul": {
      listStyleType: "square"
    }
  }),
  listItem: i({
    marginLeft: "spacing-400",
    display: "list-item"
  }),
  paragraph: i({
    "& + *": {
      marginTop: "spacing-200"
    },
    fontSize: "lg"
  }),
  root: i({})
}), p = l({
  baseStyle: a
});
export {
  p as EditorOutput
};
//# sourceMappingURL=EditorOutput.es.js.map
